import heartHealthHeroGradients from '@/app/[locale]/heart-health/_data/heartHealthHeroGradients';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const HeartHealthHero = () => {
  return (
    <LandingPageHero
      backgroundProps={{
        color: 'sandstone-400',
        gradients: heartHealthHeroGradients,
      }}
      copy="heart_health_hero_subtitle"
      data-cy="heart-health-hero"
      eyebrow="heart_health_link"
      images={[
        {
          localizedAlt: 'heart_health_beverage_alt',
          src: 'blue-sky/heart-health/heart-health-hero-beverage',
        },
        {
          localizedAlt: 'heart_health_man_closeup_alt',
          src: 'blue-sky/heart-health/heart-health-hero-man-smiling',
        },
      ]}
      textColor="text-brown-600"
      title="heart_health_hero_title_2024"
    />
  );
};

export default HeartHealthHero;
